import { SelectItemData } from '.';

export const pronouns: SelectItemData = [
  { value: 'SHE_HER', label: 'she/her' },
  { value: 'HE_HIM', label: 'he/him' },
  { value: 'THEY_THEM', label: 'they/them' },
  { value: 'OTHER', label: 'Other…' },
];
